import React, { PureComponent } from "react";

export default class CloseViewer extends PureComponent {
  render() {
    return (
      <div className="rmodal__close">
        <button className="close " onClick={this.props.closeViewer} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Reveal/CloseViewer/index.js